import { createSlice } from "@reduxjs/toolkit";
import { getpgeactivityskillThunk, createpgeskillmasterThunk, updatepgeskillmasterThunk, deletepgeskillmasterThunk } from "./PgeSkillsetManager.Thunk";

const initialState = {
  data: [],
  loading: false,
  status: "",
  message: "",
  preferedlanguage: "",
  subject: "",
  clas: "",
  disable_content_button: true,
};

const PgeSkillsetManagerSlice = createSlice({
  name: "pgeskillsetmanagerslice",
  initialState,
  reducers: {
    preferedlanguage_change: (state, action) => {
      state.preferedlanguage = action.payload;
      state.data = [];
      state.subject = "";
      state.clas = "";
      state.disable_content_button = true;
    },
    subject_change: (state, action) => {
      state.subject = action.payload;
      state.data = [];
      state.clas = "";
      state.disable_content_button = true;
    },
    class_change: (state, action) => {
      state.clas = action.payload;
      state.data = [];
      state.disable_content_button = false;
    },
  },
  extraReducers: {
    [getpgeactivityskillThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getpgeactivityskillThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [getpgeactivityskillThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createpgeskillmasterThunk.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createpgeskillmasterThunk.fulfilled]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [createpgeskillmasterThunk.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [updatepgeskillmasterThunk.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updatepgeskillmasterThunk.fulfilled]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [updatepgeskillmasterThunk.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [deletepgeskillmasterThunk.pending]: (state, action) => {
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [deletepgeskillmasterThunk.fulfilled]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "Login success";
    },
    [deletepgeskillmasterThunk.rejected]: (state, action) => {
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { preferedlanguage_change, class_change, subject_change } = PgeSkillsetManagerSlice.actions;

export default PgeSkillsetManagerSlice.reducer;
